export const logout = () => {
  console.log('logout')
  document.cookie.split(';').forEach(c => document.cookie = c.split('=')[0].trim() + '=;expires=' + new Date(0).toUTCString() + ';path=/;')
  location.reload()
}